import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { modals } from '@mantine/modals';

import { useCurrentTeam } from 'hooks/use-current-team';
import { useCurrentUser } from 'hooks/use-current-user';
import { UserService } from 'services/UserService';

const UserSuggestions = () => {
    const user = useCurrentUser();
    const team = useCurrentTeam();
    const { pathname, query } = useRouter();

    useEffect(() => {
        if (!user || !team) {
            return;
        }

        const excluded = [
            '/token',
            '/account',
            '/teams/[id]/request-access',
            '/profiles/[slug]',
            '/profiles/[slug]/request-access',
            '/profiles/signup',
        ];

        if (excluded.find((part) => pathname.includes(part))) {
            return;
        }

        if (query.switchTeam) {
            return;
        }

        const teamNameIsEmail = team.name === user.email;

        const teamSuggestions = user.teamSuggestions || [];
        const teamSuggestionsDismissed = user.teamSuggestionsDismissed || false;

        const companySuggestions = user.companySuggestions || [];
        const companySuggestionsDismissed = user.companySuggestionsDismissed || false;

        if (teamNameIsEmail) {
            modals.openContextModal({
                modal: 'teamNameRequired',
                innerProps: {},
                withCloseButton: false,
                closeOnClickOutside: false,
                centered: true,
            });
        } else if (teamSuggestions.length && !teamSuggestionsDismissed) {
            modals.openContextModal({
                modal: 'teamSuggestions',
                innerProps: {
                    teamSuggestions,
                },
                withCloseButton: false,
                closeOnClickOutside: false,
                centered: true,
                onClose: () => {
                    UserService.dismissTeamSuggestions(user.id).then();
                },
            });
        } else if (companySuggestions.length && !companySuggestionsDismissed && !user.hasCompany) {
            modals.openContextModal({
                modal: 'companySuggestions',
                innerProps: {
                    companySuggestions,
                },
                withCloseButton: false,
                closeOnClickOutside: false,
                centered: true,
                onClose: () => {
                    UserService.dismissCompanySuggestions(user.id).then();
                },
            });
        }
    }, [
        pathname,
        query.switchTeam,
        user?.id,
        user?.teamSuggestionsDismissed,
        user?.companySuggestionsDismissed,
        team?.id,
        team?.name,
    ]);

    return null;
};

export { UserSuggestions };
